export default "__VITE_ASSET__6f47e593__"